import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import Loader from './components/Loader';
import './index.scss';
import AppShell from './AppShell';
import { browserHistory } from './history';
import { PersistGate } from 'redux-persist/lib/integration/react';

// import the two exports from the last code snippet.
import { persistor, store } from './store';
import {
  verifyTenent,
  onCheckAutherizationToken,
  getTenantGUID,
} from './Tenants';
import { webUrlAccess } from './common/constants';
import { BrandingProvider } from './branding/BrandingContextProvider';

if (
  window.location.protocol === 'http:' &&
  !window.location.hostname.includes('app.localhost')
) {
  window.location.href = window.location.href.replace('http:', 'https:');
}

const tenantId = getTenantGUID(webUrlAccess);

const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <BrandingProvider tenantId={tenantId}>
        <Router history={browserHistory}>
          <AppShell />
        </Router>
      </BrandingProvider>
    </PersistGate>
  </Provider>
);

// Add Produktly script after React app renders.
// It breaks the sourcemap for dev builds, so only add it for non-dev builds.
(function (w, d, f) {
  w.Produktly =
    w.Produktly ||
    new Proxy(() => {}, {
      get: function (_, n) {
        return (...a) => {
          w.ProduktlyQ = (w.ProduktlyQ || []).concat([[n, a]]);
        };
      },
      apply: function (_, __, a) {
        w.ProduktlyQ = (w.ProduktlyQ || []).concat([['apply', a]]);
      },
    });
  var a = d.getElementsByTagName('head')[0];
  var s = d.createElement('script');
  s.async = 1;
  s.src = f;
  s.setAttribute('id', 'produktlyScript');
  s.dataset.clientToken = import.meta.env.VITE_PRODUKTLY_CLIENT_TOKEN;
  a.appendChild(s);
})(window, document, 'https://public.produktly.com/js/main.js');

onCheckAutherizationToken();
verifyTenent(webUrlAccess);
